import React from "react";
import { injectIntl } from "react-intl";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import Link from "next/link";
import { SectionTitle, Sidebar } from "../../../src/components";

import styles from "./Checkout.styles.css";
import Form from "./components/Form";
import Resume from "./components/Resume";

const getConfig = require("next/config").default;
const { publicRuntimeConfig } = getConfig();
const { STRIPE_KEY } = publicRuntimeConfig;
const stripePromise = loadStripe(STRIPE_KEY);

const Checkout = ({
  cart,
  onLoginRequest,
  countries,
  user,
  destination,
  lang,
  pathname,
  intl,
  success,
  cancel,
  qrs
}) => {
  const { products, recommended } = cart;

  const showSignInDialog = (event) => {
    event.preventDefault();
    if (onLoginRequest) onLoginRequest();
  };

  return (
    <Sidebar>
      <Sidebar.Content>
        <SectionTitle
          title={intl.formatMessage({ id: "checkout.billing-information" })}
          intl={intl}
        />

        {!user && (
          <a
            href="#signin"
            onClick={showSignInDialog}
            className={styles.alertBox}
          >
            <span className={styles.alertBoxTitle}>
              {intl.formatMessage({ id: "checkout.signin.title" })}
            </span>
            <span className={styles.alertBoxMessage}>
              {intl.formatMessage({ id: "checkout.signin.message" })}
            </span>
          </a>
        )}
        <br />
        { success &&
          <>
            <p>
              {intl.formatMessage({ id: "checkout.success" })}
            </p>
            <Link
              href={`/cancellation-policy?locale=${intl.locale}&destination=${destination.rawId}&`}
              as={`/${intl.locale}/${destination.rawId}/cancellation-policy`}
            >
              <a>
                <span>
                  {intl.formatMessage({ id: "checkout.cancellation.policy" })}
                </span>
              </a>
            </Link>
          </>
        }
        { !success &&
        <p>
          {intl.formatMessage({ id: "checkout.form.checkout-description" })}
        </p>
        }
        { !success &&
          <Elements stripe={stripePromise}>
            <Form {...{ countries, cart, locale: lang, destination, qrs, user }} />
          </Elements>
        }
      </Sidebar.Content>
      <Sidebar.Bar>
        <SectionTitle
          title={intl.formatMessage({ id: "checkout.your-summary" })}
          intl={intl}
        />
        <Resume {...{ recommended, products }} />
      </Sidebar.Bar>
    </Sidebar>
  );
};

Checkout.defaultProps = {
  cart: {},
  destination: {},
  countries: [],
  lang: {},
  pathname: "",
};

export default injectIntl(Checkout);
